export default __webpack_public_path__ + "static/section_3_details_3-710eb3bb80979fc8078fbd60df350a90.png";